import { render, staticRenderFns } from "./Xyr.vue?vue&type=template&id=a7ef0c70&scoped=true&"
import script from "./Xyr.vue?vue&type=script&lang=js&"
export * from "./Xyr.vue?vue&type=script&lang=js&"
import style0 from "./Xyr.vue?vue&type=style&index=0&id=a7ef0c70&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ef0c70",
  null
  
)

export default component.exports